import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Button } from '../../common'

import * as Styles from './styles'
import * as Strings from './strings'

class OfflineModeHeader extends Component {
  constructor(props) {
    super(props)
    this.state = {
      width: window.innerWidth
    }
    this.resizeHandler = this.resizeHandler.bind(this)
  }

  componentDidMount() {
    window.addEventListener('resize', this.resizeHandler)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeHandler)
  }

  resizeHandler() {
    this.setState({ width: window.innerWidth })
  }

  render() {
    const { width } = this.state
    const { user, language, style, config } = this.props
    const extraWidth = config.menuOpen ? 240 : 72
    const innerWidth = width - extraWidth
    const information =
      innerWidth < 1050
        ? Strings.default.TEST_VERSION_SHORT[language]
        : Strings.default.TEST_VERSION[language]
    if (user.offlineModeSignedIn) {
      return (
        <div
          style={{
            ...Styles.default.containerStyle,
            width: innerWidth,
            justifyContent: innerWidth < 700 ? 'center' : 'space-between',
            ...style
          }}
        >
          {innerWidth < 700 ? null : (
            <p style={{ margin: 0, marginLeft: 10 }}>{information}</p>
          )}
          <div style={Styles.default.buttonContainerStyle}>
            <Button
              header={Strings.default.SEE_PRICE[language]}
              className={'success'}
              marginTop={0}
              marginRight={10}
              onClick={() =>
                window.location.replace('https://homepal.se/pris/')
              }
              width={150}
            />
          </div>
        </div>
      )
    }

    return null
  }
}

function mapStateToProps({ user, config }) {
  const { language } = config
  return { user, language, config }
}

export default connect(
  mapStateToProps,
  null
)(OfflineModeHeader)



// WEBPACK FOOTER //
// ./src/components/containers/OfflineModeHeader/index.js